import axios from 'axios';

const CHANGE_LOG_PARTNER_BASE_URL = `${ process.env.REACT_APP_MS_CHANGELOG_PARTNER_SECURE }`;

const autoSuggestType = {
   field: 'field',
   entityType: 'entity_type',
};

const sortByNameProperty = (a, b) => {
   const aLabel = a?.name?.toLowerCase();
   const bLabel = b?.name?.toLowerCase();
   return aLabel.localeCompare(bLabel);
};

const getAutoSuggestOptions = (keyword, type) => {
   return (
      axios.post(`${ CHANGE_LOG_PARTNER_BASE_URL }autosuggest`,
         {
            type,
            keyword,
         }).then((res) => {
         const { valueList = [] } = res?.data;
         const data = !valueList
            ? []
            : valueList.sort(sortByNameProperty).map((item) => {
               return ({
                  ...item,
                  label: item?.name,
                  value: item?.id,
               });
            });


         // Shape is like this for remoteOptionSelectFactory.
         // API: `${ CHANGE_LOG_PARTNER_BASE_URL }autosuggest`
         // Does not conform to the template for getting options
         return (
            {
               data,
            }
         );
      })
   );
};

export const getFieldOptionsByKeyword = (keyword) => {
   return getAutoSuggestOptions(keyword, autoSuggestType.field);
};

export const getEntityTypeOptionsByKeyword = (keyword) => {
   return getAutoSuggestOptions(keyword, autoSuggestType.entityType);
};
